export function getCurrentUrl() {
    return window.location.href.split('?')[0].split('#')[0];
}
//# sourceMappingURL=urls.js.map